import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Text from 'components/Text';
import Stack from 'components/Stack';
import BulletList from 'components/BulletList';
import SimpleModal from 'components/SimpleModal';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function ContentContributionsModal(_ref) {
  var onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(SimpleModal, {
    title: t('modal_allow_content_contribution_title'),
    body: /*#__PURE__*/_jsxs(Stack, {
      spacing: "m",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "p",
        children: t('modal_allow_content_contribution_intro')
      }), /*#__PURE__*/_jsxs(Trans, {
        t: t,
        i18nKey: "modal_allow_content_contribution_abilities_included_subheading",
        children: ["The option \u201CAllow everyone in audience to add and edit their own assets\u201D will give everyone with access to the playlist these", ' ', /*#__PURE__*/_jsx("strong", {
          children: "basic content contribution abilities:"
        })]
      }), /*#__PURE__*/_jsxs(BulletList, {
        children: [/*#__PURE__*/_jsx(_Fragment, {
          children: t('modal_allow_content_contribution_abilities_included_upload_files')
        }), /*#__PURE__*/_jsx(_Fragment, {
          children: t('modal_allow_content_contribution_abilities_included_edit_delete_content')
        }), /*#__PURE__*/_jsx(_Fragment, {
          children: t('modal_allow_content_contribution_abilities_included_reorder_content')
        })]
      }), /*#__PURE__*/_jsx(Text, {
        bold: true,
        as: "p",
        children: t('modal_allow_content_contribution_abilities_excluded_subheading')
      }), /*#__PURE__*/_jsxs(BulletList, {
        children: [/*#__PURE__*/_jsx(_Fragment, {
          children: t('modal_allow_content_contribution_abilities_excluded_edit_name')
        }), /*#__PURE__*/_jsx(_Fragment, {
          children: t('modal_allow_content_contribution_abilities_excluded_edit_delete_content')
        }), /*#__PURE__*/_jsx(_Fragment, {
          children: t('modal_allow_content_contribution_abilities_excluded_add_sections')
        }), /*#__PURE__*/_jsx(_Fragment, {
          children: t('modal_allow_content_contribution_abilities_excluded_view_analytics')
        })]
      })]
    }),
    buttons: [{
      label: t('actions_got_it'),
      onClick: onClose
    }],
    onClose: onClose
  });
}
export default ContentContributionsModal;